export function pluralize(count: number, word: string, suffix = "s") {
  return `${count} ${word}${count === 1 ? "" : suffix}`;
}

export function joinStrings(
  items: (string | boolean | null | undefined)[],
  separator = " ",
) {
  return items.filter(Boolean).join(separator);
}

export function toCapitalCase(text: string) {
  return text.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
}

export function formatTextWithCount(
  name: string,
  count: number | undefined | null,
) {
  return count === undefined ? name : `${name} (${count})`;
}
